// extracted by mini-css-extract-plugin
export default {"innerWrapper":"CA-z","tooltipWrapper":"DA-z","icon":"EA-z","tooltip":"FA-z","content":"GA-z"};